export enum CheckoutRecalculationStatusEnum {
  InternallyRejected = 'INTERNALLY_REJECTED',
  Prepared = 'UPDATE_PREPARED',
  Rejected = 'UPDATE_REJECTED',
  Started = 'UPDATE_STARTED',
}
